import React, { useEffect, useState,useMemo,useCallback ,useContext,useRef} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import $ from 'jquery';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import RefreshContext from './RefreshContext';
import OrgChartNode from './OrgChart';
import qs from 'qs';
import styless from './css/org.module.css';
import { Box, Button, Select as MuiSelect, MenuItem, Typography, Tooltip, TextField, Table,TableBody,TableCell,TableContainer,TableHead, TableRow, TableSortLabel, IconButton, Menu,ListItemIcon,} from '@mui/material'; 
import { ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline, EditOutlined, VisibilityOutlined } from '@mui/icons-material';
function Copy() {
    const { refreshKey } = useContext(RefreshContext);
  
    const [confirmSubmit, setConfirmSubmit] = useState(false);

  const navigate = useNavigate();

  const [jobDescription, setJobDescription] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [rname,setRname]= useState(null);
  const [organizationalData,setAssign] = useState([]);
  const [requirement, setRequirement] = useState(null);

  const { aid } = useParams();

  const [staff, setStaff] = useState([]);

  const [selectedGender, setGender] = useState('');
  const [selectedCost, setCost] = useState(null);
  const [education, setEducation] = useState([]);
  const [selectPlace, setPlacement] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [client, setClient] = useState([]);
  const [reqpost, setreqpost] = useState([]);
  const [team, setTeam] = useState([]);
  const [vendor,setVendor]= useState([]);

  const [remark, setText] = useState("");
  const [commentButtonName,setButtonName]= useState("Submit Comment");
  const [loading, setTableLoading] = useState(true);

  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [selectedVendor,setSelectedVendor]= useState([]);

  const [poatype,setpoatype]= useState(null);
   const [poatypes,setpoatypes]= useState(null);
  const [poaData,setPoaDetails] = useState(null);
const initialPoaData = {
  first: "",
  second: "",
  third: "",
  fourth: "",
  poaid: "", hidden:""
};

const [poaDataa, setPoaData] = useState(initialPoaData);
const poaHandleChange = (e) => {
  const { name, value } = e.target;
  setPoaData((prev) => ({ ...prev, [name]: value }));
};

const [designation, setDesignation] = useState([]);
  
const [rejectId, setRejectId] = useState(null);
const [rejectremark, setRemark] = useState("");
const [poaHistory,setPoahistory] = useState([]);
  const [order, setOrder] = useState('asc'); 
    const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
    const [globalFilterText, setGlobalFilterText] = useState('');
    const [columnFilters, setColumnFilters] = useState({});
  const [pendingId, setPendingId] = useState(null);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [placementType,setPlacements] = useState([]);
  const [qualificationOptions,setQual]= useState([]);
  const [costCenterOptions,setCostCenter]= useState([]);
  
  const [metaData, setMetaData] = useState({
    appname: '',
    edit: false,
    del: false,
    add: false,
    view: false,
    typess: '', request:false, crequest:false,
    icon: '',
    defaultShow: 10,
    bd:false,manager:false,uploadCandidates:false,vendor:false,
    showManager:false,poaShow:0,smdekha:0,
    poa:false,
    appname2:'',
    assigned:0
  });

  const [stats,setStats]= useState([]);

  const [dates, setDates] = useState({
  planFromDate: null,
  planToDate: null
});
const [searchData, setSearchData] = useState({
  dateRange: [] // This will store [startDate, endDate]
});


  const GenderOptions = [
    { value: 'male', label: 'MALE' },
    { value: 'female', label: 'FEMALE' },
    { value: 'all', label: 'ALL' }
  ];

   const typeUpper = metaData.typess?.toUpperCase();
const setInput = (e) => {
  setInputValue(e.target.value);
};

   const dynamicFilterOptions = useMemo(() => {
        const options = {};
        const selectAccessors = ['contract', 'pType', 'rstatus'];
        
        selectAccessors.forEach(key => {
            const uniqueValues = new Set();
            staff.forEach(row => {
                if (row[key]) {
                    uniqueValues.add(row[key]);
                }
            });
            options[key] = Array.from(uniqueValues).sort();
        });
        return options;
    }, [staff]);

    const shouldIncludeActionColumn = (
        metaData.typess?.toUpperCase() === "ADMIN" ||
        metaData.bd === 1
);

const [debouncedSearch, setDebouncedSearch] = useState("");

useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearch(globalFilterText);
    setCurrentPage(1); // Reset to page 1 on new search
  }, 500);

  return () => clearTimeout(handler);
}, [globalFilterText]);

const [currentPage, setCurrentPage] = useState(1);
const [totalRows, setTotalRows] = useState(0); // Set this from your API response
const limit = 50; 
const maxPage = Math.ceil(totalRows / limit);

  const fetchData = async (page,search = "", start = "", end = "") => {
    setLoading(true);
    const queryUrl = `${apiurl}requirement.php?subdomain=react&page=${page}&aid=${aid}&search=${search}&startDate=${start}&endDate=${end}`;
    const response = await axios.get(queryUrl);

    setStaff(response.data.staff);
    setTotalRows(response.data.total_count);
    
    if(response.data.client){
    setClient(response.data.client);

    setreqpost(response.data.reqpost || []);
    setPlacements(response.data.placements || []);
    setQual(response.data.qualifications || []);
    setCostCenter(response.data.costcenters || []);

    setTeam(response.data.team || []);
    setVendor(response.data.vendor || []);
   }
 
    setMetaData({
      appname: response.data.appname,
      edit: response.data.edit,
      del: response.data.del,
      add: response.data.add,
      view: response.data.view,
      typess: response.data.typess,
      icon: response.data.icon,
      defaultShow: response.data.defaultShow,
      bd:response.data.bd,
      manager:response.data.manager,
      uploadCandidates:response.data.uploadCandidates,
      vendor:response.data.vendorShow,
      showManager:response.data.showManager,
      poa:response.data.poa,
      request:response.data.request, crequest:response.data.crequest, appname2:response.data.appname2,
      assigned:response.data.assigned,
      poaShow:response.data.poaShow,
      smdekha:response.data.smdekha
    });
    setStats(response.data.stats);
    setTableLoading(false);
    setLoading(false);
  };

const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

  
  useEffect(() => {
    fetchData(currentPage,debouncedSearch);
  }, [refreshKey,currentPage,debouncedSearch]);

useEffect(() => {
  if (searchData.dateRange.length === 2 || searchData.dateRange.length === 0) {
    
    let startDate = "";
    let endDate = "";

    if (searchData.dateRange.length === 2) {
      const formatDate = (date) => {
          const d = new Date(date);
          const month = `0${d.getMonth() + 1}`.slice(-2);
          const day = `0${d.getDate()}`.slice(-2);
          return `${d.getFullYear()}-${month}-${day}`;
      };

      startDate = formatDate(searchData.dateRange[0]);
      endDate = formatDate(searchData.dateRange[1]);
    }

    // Call your API function with the new dates
    fetchData(1, debouncedSearch, startDate, endDate);
  }
}, [searchData.dateRange]);

  const FormSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData($("#submitform")[0]);

      const payload = {
        ...dates,
        planFromDate: dates.planFromDate ? dates.planFromDate.toISOString().split("T")[0] : "",
        planToDate: dates.planToDate ? dates.planToDate.toISOString().split("T")[0] : "",
        description: jobDescription,
        clientName: selectedClient,
        designation: designation,
        education: education,
        costCenter: selectedCost,
        gender:selectedGender,
        placementType:selectPlace
      };

      const payload2 = {
        ...dates,
        planFromDate: dates.planFromDate ? dates.planFromDate.toISOString().split("T")[0] : "",
        planToDate: dates.planToDate ? dates.planToDate.toISOString().split("T")[0] : "",
        clientName: selectedClient,
        designation: designation,
        education: education,
        costCenter: selectedCost,
        gender:selectedGender,
        placementType:selectPlace
      };
      
      for (const [key, value] of Object.entries(payload2)) {
        if (!value || value === "") {
          Swal.fire({
            icon: "warning",
            title: "Missing Field",
            text: `Please fill in ${key}`,
            confirmButtonColor: "#3085d6",
          });
          return false; // stop here
        }
      }

      if (!confirmSubmit) {
        setShowConfirmModal(true);
        return;
     }
  
      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value || "");
      });
      setLoading(true);
      const response = await axios.post(apiurl + "requirement.php", formData);

      if (response.data.status == true) {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $("#exampleModal .btn-close").click();
          $("#exampleModal #hidden").val("");
          $("#exampleModal #reset").click();
        
          $("#submitform .btn-danger").click();
          fetchData(currentPage);
        });
      }
      else {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
      setLoading(false);
    }

  };

  const DeleteData = async (id) => {
    if (!id) { return false; }
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.get(apiurl + "requirement.php?del=" + id);

        if (response.data.status == true) {
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            fetchData(currentPage);
          });

        }
        else {
          console.log(response.data.message);
        }
      }
      catch (error) {
        console.error('Error deleting category:', error);
      }


    };

  };

  //edit the form
  const EditData = async (edit, sss) => {
    if (edit) {
      $("#showLoader").removeClass('d-none').addClass('d-flex');
      setJobDescription("");
      try {
        const response = await axios.get(apiurl + 'requirement.php?edit=' + edit+"&sss="+sss);
        if (response.data.status == true) {

          if (sss == '1') {
            const data = response.data.data[0];
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const value = (data[key] ?? "").toString().trim();
                $(`[name="${key}"]`).val(value);
              }
            }

            setDates({
              planFromDate: data.planFromDate ? new Date(data.planFromDate) : null,
              planToDate: data.planToDate ? new Date(data.planToDate) : null,
            });
            
            setGender(data.gender || "");
            setPlacement(data.placementType || "");

            setSelectedClient(data.clientName || "");

            setCost(data.costCenter || "");
            
            setEducation(data.education || []);
            setDesignation(data.designation || []);
            setJobDescription(data.jobDescription || "");

            const offcanvasEl = document.getElementById("exampleModal");
             if (offcanvasEl) {
                 new window.bootstrap.Offcanvas(offcanvasEl).show();
             }
          }
          else if(sss=='assign'){
             setAssign(response.data.assign);
             setRname(response.data.rname);
             $("#site_map_modal").click();
          }
          else {
            setRequirement(response.data.data[0]);
            $("#tera_modal3").click();
          }

          $("#showLoader").removeClass('d-flex').addClass('d-none');
        } else {
          // modal can't show
          $("#showLoader").removeClass('d-flex').addClass('d-none');
          alert("data not found");
        }

      }
      catch (error) {
        console.error('Error deleting category:', error);
      }

    }

  };

  const updateDetails = async (idd, val) => { 
    setLoading(true);
    
    if (val == '1' || val == '2' || val == '3' || val == '4') {
       const response = await axios.get(apiurl + 'requirement.php?com=' + idd + "&value=" + val);
      setInputValue(response.data.value || "");
      $("#showornot").show();
      switch (val) {
        case "1":
          setText("BD Comment");
          break;
        case "2":
          setText("SM REMARK");
          break;
        case "3":
          setText("SH REMARK");
          break;
        case "4":
          setText("Job Description");
          $("#showornot").hide();
          break;
      }
      $("#tera_modal").click();
      $("#allModal #hiddens").val(response.data.hidden);
      $("#allModal #type").val(val);
   }
    else {
      setSelectedTeam([]);
      setSelectedVendor([]);
      const response = await axios.get(apiurl + 'allotement.php?com=' + idd + "&value=" + val);
      
      $("#tera_modal2").click();
      $("#SourceForm #hiddens").val(response.data.hidden);
      $("#SourceForm #type").val(val);
      $("#SourceForm #clients").val(response.data.client);
      $("#SourceForm #locations").val(response.data.location);
      $("#SourceForm #posts").val(response.data.designation);
      
      const source = response.data.source;
      const vendor = response.data.vendor;

       setSelectedTeam(source && source.trim() !== "" ? source.split(",").map(id => id.trim()) : []);
       setSelectedVendor(vendor && vendor.trim() !== "" ? vendor.split(",").map(id => id.trim()) : []);
    }
    setLoading(false);

  };

  const setLoading = (show) => {
    if (show) {
      $("#showLoader").removeClass("d-none").addClass("d-flex");
    } else {
      $("#showLoader").removeClass("d-flex").addClass("d-none");
    }
  };

  
  const UpdateForm = async (e) => {
    e.preventDefault();
    
    if (pendingId && pendingStatus) {
     if(pendingStatus=="2"){
      if(inputValue==""){
         
        Swal.fire({
        position: "top-center",
        icon: "error",
        title: "Remark is compulsory",
        showConfirmButton: false,
        timer: 2000,
      });
       return false;
         
      }
    }
    handleChanges(pendingId, pendingStatus, inputValue);
    }
    else{
      setLoading(true);
    try {
      const formData = new FormData($("#updateForm")[0]);
      formData.append("comment", inputValue);
      
      const response = await axios.post(apiurl + "requirement.php", formData);

      if (response.data.status == true) {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $("#okayClose").click();
        });
      }
      else {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
      setLoading(false);
    }
    }
  };

  const SourceForm = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData($("#SourceForm")[0]);
      formData.append("source", selectedTeam);
      formData.append("vendor",selectedVendor);
      formData.append("aid", aid);
      setLoading(true);
      const response = await axios.post(apiurl + "allotement.php", formData);
     
       if (response.data.status == true) {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $("#okayClose2").click();
          $("#SourceForm .btn-danger").click();
        });
      }
      else {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
      setLoading(false);
    }
  };

  const handleChanges = async (idd, sta,remark="") => {
    setLoading(true);
    try {
      const response = await axios.post(
        apiurl + "status.php",
        qs.stringify({
          id: idd,
          status: sta,
          remark:remark,
          table: "requirements",
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      setLoading(false);
      
      Swal.fire({
        position: "top-center",
        icon: response.data.icons,
        title: response.data.messages,
        showConfirmButton: false,
        timer: 2000,
      }).then(()=>{
         setPendingId(null); setPendingStatus(null);setText("");setButtonName(""); $("#allModal .btn-close").click();
      });
    } catch (error) {
      setLoading(false);
      console.error("Update failed:", error);
     
    }
  };

  const showFixedDropdown = (e) => {
  e.preventDefault();
  const rect = e.target.getBoundingClientRect();
  const menu = document.querySelector("#fixedDropdownMenu");

  menu.style.top = rect.bottom + "px";
  menu.style.left = (rect.left-100) + "px";
  menu.classList.toggle("show");
};

useEffect(() => {
  const handleScroll = () => {
    document.querySelectorAll(".dropdown-menu.show").forEach(menu => {
      menu.classList.remove("show");
    });
  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
}, []);


  const poadetails = async (idd,tye,poa) =>{
    setPoaData(initialPoaData);
    setLoading(true);
    const response = await axios.get(apiurl + 'status.php?poa=' + idd+"&aid="+aid+"&tye="+tye);
    
    if(tye === 1 ){
     setPoahistory(response.data.poaHistory);
     
    setPoaData({
        first: response.data.first || "",
        second: response.data.second || "",
        third: response.data.third || "",
        fourth: response.data.fourth || "",
        poaid: response.data.poaid || "",
        hidden:response.data.hidden
      });
    }
    else{
      setPoaDetails(response.data);
    }
     $("#tera_modal4").click();
    setpoatype(tye);
    setpoatypes(poa);
    setLoading(false);
    if(!response.data.lavesh){
    console.log(response.data.lavesh);
    }
  };

  const PoaSubmit = async (e)=>{
    e.preventDefault();
    setLoading(true);
    try {
      const formData=new FormData(e.target);
      const response = await axios.post(apiurl + "status.php",formData);

        setLoading(false);
    
      Swal.fire({
        position: "top-center",
        icon: response.data.icons,
        title: response.data.messages,
        showConfirmButton: false,
        timer: 2000,
      }).then(()=>{
        if(response.data.successs==true){
        $(".btn-close").click();
        }
      });

    } catch (error) {
      setLoading(false);
      console.error("Update failed:", error);
    }
  };
 
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(staff);

  useEffect(() => {
    document.title = "Requiement | MERAQUI";
  }, [searchText, staff]);

const Action = async (id, typ, remarkText = "") => {
  setLoading(true);
  try {
    const response = await axios.post(
      apiurl + "status.php",
      qs.stringify({
        id: id,
        status: typ,
        table: "poa",
        remark: remarkText, // send remark only for reject
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    setLoading(false);

  if (response.data.icons === "success") {
  setPoaDetails((prev) => {
    const updateRow = (rows) =>
      rows.map((r) =>
        r.poaid === id ? { ...r, status: typ } : r
      );

    return {
      ...prev,
      staffWise: updateRow(prev.staffWise),
      vendorWise: updateRow(prev.vendorWise),
    };
  });
  }


    Swal.fire({
      position: "top-center",
      icon: response.data.icons,
      title: response.data.messages,
      showConfirmButton: false,
      timer: 2000,
    });
  } catch (error) {
    setLoading(false);
    console.error("Update failed:", error);
  }
};

const handleSelectChange = (idd, sta) => {
    setPendingId(idd);
    setPendingStatus(sta);
    setText("Requirement Status Remark");
    setButtonName("Update Status");
    $("#tera_modal").click();
  };

const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = (a, b, orderBy) => {
    const valA = orderBy(a);
    const valB = orderBy(b);

    if (valB < valA) {
        return -1;
    }
    if (valB > valA) {
        return 1;
    }
    return 0;
};

const RenderActionCell = ({ rowData, metaData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setAnchorEl(null);
    };

    const handleItemClick = (handler, ...args) => (e) => {
        e.stopPropagation();
        handler(...args);
        setAnchorEl(null);
    };

    const typeUpper = metaData.typess?.toUpperCase();
    const isStaff = typeUpper === "STAFF";
    const isAdmin = typeUpper === "ADMIN";
    const isVendor = typeUpper === "VENDOR";
    const isStaffOrVendor = isStaff || isVendor;

    const isActionRequired = isAdmin || isVendor || metaData.del === 1 || metaData.view === 1 || metaData.add === 1 || metaData.edit === 1 || metaData.bd === 1;

    if (!isActionRequired) {
        return <Typography variant="caption" color="textSecondary">—</Typography>;
    }

   return (
  <>
    <IconButton
      aria-label="more"
      aria-controls={open ? 'action-menu' : undefined}
      aria-haspopup="true"
      onClick={handleClick}
      size="small"
    >
      <MoreVertIcon sx={{ fontSize: '1.1rem', color: "black" }} />
    </IconButton>

    <Menu
      id="action-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      onClick={(e) => e.stopPropagation()}
      MenuListProps={{ disablePadding: true }}
      PaperProps={{ sx: { borderRadius: 1, boxShadow: 3 } }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {/* 1. Delete Option - This is fine as it returns a single MenuItem */}
      {(isAdmin || metaData.del === 1) && (
        <MenuItem onClick={handleItemClick(DeleteData, rowData.hidden)} sx={{ fontSize: '0.85rem' }}>
          <ListItemIcon><DeleteOutline fontSize="small" /></ListItemIcon>
          Delete
        </MenuItem>
      )}

      {/* 6. Other Details - FIX: Use an array instead of a Fragment */}
      {(isAdmin || metaData.bd === 1) && [
        <MenuItem key="bd" onClick={handleItemClick(updateDetails, rowData.hidden, "1")} sx={{ fontSize: '0.85rem' }}>BD Comment</MenuItem>,
        <MenuItem key="sm" onClick={handleItemClick(updateDetails, rowData.hidden, "2")} sx={{ fontSize: '0.85rem' }}>SM REMARK</MenuItem>,
        <MenuItem key="sh" onClick={handleItemClick(updateDetails, rowData.hidden, "3")} sx={{ fontSize: '0.85rem' }}>SH REMARK</MenuItem>,
        <MenuItem key="jd" onClick={handleItemClick(updateDetails, rowData.hidden, "4")} sx={{ fontSize: '0.85rem' }}>JOB DESCRIPTION</MenuItem>
      ]}
    </Menu>
  </>
);
};

const ColumnHeaderWithFilter = ({ 
    column, 
    orderBySelector, 
    order, 
    handleRequestSort, 
    columnFilters, 
    setColumnFilters,
}) => {

    const [localOpenKey, setLocalOpenKey] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tempFilter, setTempFilter] = useState("");

    const accessorKey = column.accessorKey;

    const isMenuOpen = localOpenKey === accessorKey;
    const currentFilter = String(columnFilters[accessorKey] || '');
    const isSorted = orderBySelector === column.selector;

    useEffect(() => {
        setTempFilter(currentFilter);
    }, [currentFilter]);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
        setTempFilter(currentFilter);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    const handleFilterChange = (e) => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: e.target.value
        }));
    };

    const handleTempChange = (e) => {
        setTempFilter(e.target.value);
    };

    const applySearch = () => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: tempFilter
        }));
        handleClose();
    };

    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;

    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {

        if (column.filterType === 'select') {

            const filterOptions = column.dynamicFilterOptions || [];

            return (
                <MuiSelect
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    sx={{ width: '100%' }}
                >
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    label={`Filter ${column.header}`}
                    type="date"
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: '100%' }}
                />
            );
        }

        // Default: text filter (with Search button)
        return (
            <>
                <TextField
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={tempFilter}
                    onChange={handleTempChange}
                    autoFocus
                    sx={{ width: '100%' }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            applySearch();
                        }
                    }}
                />

                <Button
                    variant="contained"
                    size="small"
                    onClick={applySearch}
                    sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                >
                    Search
                </Button>
            </>
        );
    };


    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                '& .MuiTableSortLabel-root': { flexGrow: 1 }
            }}
        >
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                sx={{
                    cursor: isSortable ? 'pointer' : 'default',
                    justifyContent: column.headerAlign === 'center' ? 'center' : 'flex-start',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {isFilterable && (
                <>
                    <IconButton
                        aria-label="filter"
                        size="small"
                        onClick={handleClick}
                        sx={{
                            ml: 1,
                            p: 0,
                            color: currentFilter ? 'primary.main' : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()}
                        PaperProps={{
                            sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >

                        <Box sx={{ width: '100%', p: 1 }}>
                            {renderFilterInput()}
                        </Box>

                        {currentFilter && (
                            <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({
                                        ...prev,
                                        [accessorKey]: ''
                                    }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                            >
                                Clear Filter
                            </Button>
                        )}

                    </Menu>
                </>
            )}
        </Box>
    );
};

 const columns = useMemo(() => {
   let baseColumns = [
            { accessorKey: 'rid', header: 'Req. ID', size: 250, selector: (row) => row.rid, filterType: 'text', headerAlign: 'center' },
            { accessorKey: 'recname', header: 'BD Name', size: 150, selector: (row) => row.recname, filterType: 'text' },
            { accessorKey: 'name', header: 'Client Name', size: 150, selector: (row) => row.name, filterType: 'text' },
            { 
                accessorKey: 'contract', 
                header: 'Contract', 
                size: 150, 
                selector: (row) => row.contract, 
                filterType: 'select', 
                dynamicFilterOptions: dynamicFilterOptions['contract'] 
            },
            { 
                accessorKey: 'pType', 
                header: 'PlacementType', 
                size: 150, 
                selector: (row) => row.pType, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['pType']
            },
            { accessorKey: 'position', header: 'No. of Position', size: 100, selector: (row) => row.position },
            { accessorKey: 'closed', header: 'Closed Position', size: 100, selector: (row) => row.closed },
            { 
                accessorKey: 'planDates', 
                header: 'Plan Dates', 
                size: 150, 
                selector: (row) => row.planDates, 
                filterType: 'date' 
            },
            { 
                accessorKey: 'rstatus', 
                header: 'Requirement Status', 
                size: 150, 
                selector: (row) => row.rstatus, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['rstatus']
            },
            { accessorKey: 'location', header: 'Location', size: 150, selector: (row) => row.location, filterType: 'text' },
            { 
                accessorKey: 'date', 
                header: 'Request Time', 
                size: 150, 
                selector: (row) => row.date, 
                filterType: 'date' 
            },
        ];

        if ( metaData.bd == 1) {
            baseColumns.push({
                accessorKey: 'statues',
                header: 'Status',
                size: 150,
                selector: (row) => row.statues,
            });
            baseColumns.push({
                accessorKey: 'bd_poa',
                header: 'View POA',
                size: 150,
                selector: (row) => row.statues,
            });
            baseColumns.push({
                accessorKey: 'assign',
                header: 'Assign To',
                size: 150,
                selector: (row) => row.assign,
            });
        }
        if(metaData.vendor === 1 && metaData.typess?.toUpperCase()=="STAFF"){
            baseColumns.push({
                accessorKey: 'assign',
                header: 'Assign To',
                size: 150,
                selector: (row) => row.assign,
            }); 
            
          if(metaData.smdekha==1){
            baseColumns.push({
                accessorKey: 'poa',
                header: 'POA',
                size: 150,
            });
          }
        }

          if(metaData.poaShow===1 && (metaData.typess?.toUpperCase()=="STAFF"|| metaData.typess?.toUpperCase()=="VENDOR")){
             baseColumns.push({
                accessorKey: 'poa',
                header: 'POA',
                size: 150,
            });
          }
           
      if (shouldIncludeActionColumn) {
            baseColumns.push({
                accessorKey: 'actions',
                header: 'Action',
                selector: () => null, // No selector needed for sorting/filtering
                isAction: true, // Custom flag for rendering the cell
            });
        }
        
        return baseColumns;
    }, [dynamicFilterOptions,shouldIncludeActionColumn,metaData]); 

    const handleRequestSort = useCallback((selector) => {
        const isAsc = orderBySelector === selector && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBySelector(() => selector);
    }, [order, orderBySelector]);

    const processedData = useMemo(() => {
        let filtered = staff

        // 2. Apply Column Filters
        filtered = filtered.filter(row => {
            return columns.every(column => {
                const accessorKey = column.accessorKey;
                const filterValue = columnFilters[accessorKey];

                if (!filterValue) return true;
                if (!column.selector) return true;

                const rowValue = String(column.selector(row));

                switch (column.filterType) {
                    case 'select':
                        // Must match the selected value exactly
                        return rowValue === filterValue; 
                        
                    case 'date':
                        // Check if the date string (e.g., '2024-01-15') includes the filter date
                        return rowValue.includes(filterValue); 
                        
                    case 'text':
                    default:
                        // Standard case-insensitive string inclusion
                        return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                }
            });
        });

        // 3. Sorting Logic
        const sortColumn = columns.find(col => col.selector === orderBySelector);

        if (sortColumn) {
            return stableSort(filtered, getComparator(order, sortColumn.selector));
        }
        
        return filtered;

    }, [staff, columns, order, orderBySelector, columnFilters]);

    const RenderStatusChip = ({value,rowId, statusType}) => {
    const popoverRef = useRef(null);
    
    const remarkContent = (rowId[statusType]) || 'No remark available.';
    
    useEffect(() => {
        if (popoverRef.current) {
            if (window.bootstrap && window.bootstrap.Popover) {
                const existingPopover = window.bootstrap.Popover.getInstance(popoverRef.current);
                if (existingPopover) {
                    existingPopover.dispose();
                }
                new window.bootstrap.Popover(popoverRef.current, {
                    content: remarkContent,
                    placement: 'left', // You can change placement (top, bottom, right, auto)
                    trigger: 'focus', // Dismiss popover on next click outside
                    html: true,       // Allow HTML content (optional)
                    customClass: 'status-remark-popover', 
                });
            } else {
                console.error("Bootstrap JavaScript (specifically Popover) is not loaded.");
            }
        }
        return () => {
            if (popoverRef.current && window.bootstrap && window.bootstrap.Popover) {
                const popoverInstance = window.bootstrap.Popover.getInstance(popoverRef.current);
                if (popoverInstance) {
                    popoverInstance.dispose();
                }
            }
        };
    }, [remarkContent]);
    const vv=value;
    return (
      <>
        <span>{vv} </span>
           <i 
            ref={popoverRef} // Attach the ref
            className="ti ti-eye ms-2 text-info" 
            style={{ cursor: 'pointer' }} 
            data-bs-toggle="popover"
            tabIndex="0" // Makes the icon focusable for trigger: 'focus'
            role="button"
            title="View Remark"
        ></i>
      </>
    );
};

const RenderReqIdCell = useCallback(({ row }) => {
    const rowData = row;
    
    const isViewDetailClickable = true; // Set to true or use metaData.view check if needed
    
    let statsColor = '#10B981'; // Default: Green
    let pp='Requirement Active';
    if (rowData.rstatus.toLowerCase() === 'onhold') {
        statsColor = '#F59E0B'; // Amber
        pp='Requirement On-hold';
    } else if (rowData.rstatus.toLowerCase() === 'closed') {
        statsColor = '#9CA3AF'; // Gray
        pp='Requirement Closed';
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}>

           <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                <IconButton
                    size="small"
                    // The View Detail action is EditData(hidden, "2")
                    onClick={() => EditData(rowData.hidden, "2")} 
                    disabled={!isViewDetailClickable}
                    sx={{
                        color: 'orange', 
                        p: 0.5,
                        '&:hover': {
                            color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Tooltip>

         {(metaData.edit === 1) && (
           <Tooltip title="Edit" arrow>
                <EditOutlined
                    size="small"
                    
                    onClick={()=>{EditData(rowData.hidden, "1")}}
                    sx={{
                        color: '#0056b3', 
                        p: 0.5,
                    }}
                >
                    <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                </EditOutlined>
            </Tooltip>
             )}

            
             <Tooltip title={pp} arrow>
                <span
                   style={{
                        background: "none",
                        border: "none",
                        color: statsColor, // Use status color for the ID text
                        padding: 0,
                        cursor:'pointer',
                        minWidth: 0, 
                        fontWeight: 500,
                        textAlign: 'left',
                        textTransform: 'none',
                        fontSize: '0.875rem',
                        '&:hover': { backgroundColor: 'transparent' }
                    }}
                >
                    {rowData.rid}
                </span>
            </Tooltip>
            
        </Box>
    );
}, [navigate, EditData]); // Make sure EditData is included in the dependencies

  const RenderStatusSelectCell = useCallback(({ row, type }) => {
     const ss=type=="4" ? row.poa : '';
     const tt=type=="4" ? 1 : 2;
  if (type== "1") {
     return (
      <>
        <MuiSelect
            defaultValue={row.statues}
            variant="outlined"
            size="small"
            onChange={(e) => handleSelectChange(row.hidden, e.target.value)}
            sx={{
                minWidth: 120,
                borderRadius: 1,
                backgroundColor: '#fff',
                height: 35,
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'var(--primary-border, #ccc) !important', 
                },
            }}
        >
            <MenuItem value="1">In-progress</MenuItem>
            <MenuItem value="2">On Hold</MenuItem>
        </MuiSelect>
        </>
    );
  }
  else if(type=="2" || type=="3"){
    const ss=type==="2" ? '6' : '5';
     return(
      <Box className="d-flex">
              <Button
                onClick={() => {updateDetails(row.hidden, ss)}}
                sx={{ 
                    backgroundColor: 'secondary.main', // Example color
                    color: 'white',
                    minWidth:'130px',
                    fontSize: '0.75rem', textTransform: 'none', padding: '4px 8px'
                }}
            >
              {type==='2' ?' Sourcing Head' : row.shmanager === 1 ? 'Sourcing Manager' : 'Recruiter/Vendor'} 
            </Button>

       <Tooltip title="View Staff" arrow>
                <IconButton
                    size="small"
                    onClick={()=>{EditData(row.hidden, "assign")}}
                    sx={{
                        color: 'orange', 
                        p: 0.5
                    }}
                
                >
                    <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Tooltip>
      </Box>
           
            
     );
  }
  else if(type=="4" || type=="5"){
    
     const isPrimaryActionClickable = row.crequest === 1 || row.uploadCandidates === 1 || row.manager === 1;
     let idTooltipContent = '';
    if (row.manager === 1) {
        idTooltipContent = 'View Candidates';
    } else if (row.uploadCandidates === 1) {
        idTooltipContent = 'Upload Candidates';
    }
    return(
      <Box className="d-flex" style={{flexDirection:'column',gap:'10px'}}>
           <Button
                onClick={() => {poadetails(row.hidden, tt,ss)}}
                sx={{ 
                    backgroundColor: 'primary.main', // Example color
                    color: 'white',
                    minWidth:'90px',
                    fontSize: '0.75rem', textTransform: 'none', padding: '4px 8px'
                }}
            >
              {type == "4" ? row.poa === 11 ? 'POA HISTORY' : 'FILL POA' : 'View POA'}
            </Button>
          {isPrimaryActionClickable && (
                    <Button
                    onClick={isPrimaryActionClickable ? () => {
                    if (row.crequest === 1 || row.manager === 1) {
                      navigate(`/admin/vendorcandidate/${row.hidden}/3`);
                    } else if (row.uploadCandidates === 1) {
                     navigate(`/admin/vendorcandidate/${row.hidden}/2`);
                    }
                    }: undefined}
                    sx={{ 
                    backgroundColor: 'warning.main', // Example color
                    color: 'white',
                    minWidth:'140px',
                    fontSize: '0.75rem', textTransform: 'none', padding: '4px 8px'
                    }}
                    >
              {idTooltipContent}
            </Button>
          )}
    </Box>
    );
  }
  else if(type=="44"){
    return(
      <Button
                onClick={() => {poadetails(row.hidden, tt,ss)}}
                sx={{ 
                    backgroundColor: 'primary.main', // Example color
                    color: 'white',
                    minWidth:'90px',
                    fontSize: '0.75rem', textTransform: 'none', padding: '4px 8px'
                }}
            >
              {type == "4" ? row.poa === 11 ? 'POA HISTORY' : 'FILL POA' : 'View POA'}
            </Button>
    );
  }
}, [handleSelectChange,EditData,updateDetails]);

function OrgChartTimeline() {
  const rootNode = organizationalData[0];
  return (
    <>
     <div className={styless.container}>
        <ul className={styless.nodeList}>
          {organizationalData.map(bdNode => (
             <OrgChartNode 
                key={bdNode.id} 
                node={bdNode} 
            />
          ))}
        </ul>
    </div>
    </>
  );
}

return (
    <>
    {/* modal all */}
      <button data-bs-toggle="modal" id="site_map_modal"  data-bs-target="#siteModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="confirm_modal"  data-bs-target="#onboardConfirmModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="tera_modal"  data-bs-target="#allModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="tera_modal2" data-bs-target="#sourceModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="tera_modal3" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="offcanvas" id="tera_modal4" data-bs-target="#POAmodal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="reject_modalbtn" data-bs-target="#rejectModal" type="button" style={{ display: 'none' }}></button>

<div id="onboardConfirmModal" tabIndex="-1" aria-labelledby="onboardConfirmModalLabel" aria-hidden={!showConfirmModal} className={`modal fade effect-sign ${showConfirmModal ? "show" : ""}`} style={{ display: showConfirmModal ? "block" : "none" }}>
<div className="modal-dialog modal-md modal-dialog-centered">
    <div className="modal-content" style={{boxShadow:'0 8px 30px rgba(0,0,0,0.35)'}}>
  
  <div className="modal-body text-center">
     <p className='fs-19'>
            Are you sure you want to onboard this Requirement ?
          </p>
 <div className="d-flex justify-content-center mt-3 gap-2">
  
 <button
 type="button"
 className="btn btn-secondary"
 data-bs-dismiss="modal"
        onClick={() => setShowConfirmModal(false)} // Hide modal on Cancel
 >
 Cancel
 </button>
<button
  type="button"
  className="btn btn-primary"
  onClick={() => {
    setConfirmSubmit(true);       // allow submit
    setShowConfirmModal(false);   // hide modal
    setTimeout(() => {
      $("#mainSubmit").click();  // now submit works
    }, 50);
  }}
>
  OK
</button>

 </div>
 </div>
</div>
</div>
</div>

   <div className="modal effect-flip-horizontal fade" id="siteModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="siteModal" aria-hidden="true">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" >{rname}</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
             <div className="modal-body" style={{padding:'0px'}}>
                <OrgChartTimeline/>
             </div>
          </div>
        </div>
      </div>

      <div className="modal effect-flip-horizontal fade" id="allModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="allModal" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" >{remark}</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="okayClose" aria-label="Close"></button>
            </div>
            <form id="updateForm" onSubmit={UpdateForm}>
              <div className="modal-body">
                   <div className="row g-3">
                  <div className="col-lg-12" >
  
  <textarea
  className="form-control"
  placeholder="Remark Compulsory"
  value={inputValue}          // ✅ bind value
  onChange={setInput}         // ✅ update state
  style={{
    maxHeight: "300px",
    overflowX: "auto",
    border: "1px solid darkgrey",
    borderRadius: "10px"
  }}
/>

                  </div>
                  <div className="col-lg-12" style={{ textAlign: 'right' }}>
                    <input type="hidden" name="hidden" id="hiddens" />
                    <input type="hidden" name="type" id="type" />
                    <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  </div>
                </div>

              </div>
              <div className='modal-footer' id='showornot' style={{ padding: '0px' }}>
                <button type="submit" className="btn btn-primary">{commentButtonName}</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body" style={{maxHeight:'90vh',overflowX:'auto'}}>
<h5><strong>Requirement Detail</strong></h5>

<table className="table table-bordered" style={{ tableLayout: "fixed" }}>
  <tbody>
    {requirement && [
      ["RecID", "Branch", "CTC ", "", requirement.rid, requirement.branchh, requirement.ctcRange,""],
      ["Gender", "RecName", "Age", "Requirement Plan Dates", requirement.gender?.toUpperCase(), requirement.recname, requirement.ageRange, requirement.planDate],
      ["Client Name", "Anchor", "Location", "Experience", requirement.cidd, requirement.anchor, requirement.location, requirement.expRange],
      ["Education Type", "Commercials", "Designation", "Contact Name", requirement.education, requirement.commercials, requirement.posts, requirement.contactName],
      ["Contract", "Placement Type", "Job Title", "Requirement Status", requirement.contract, requirement.placementType, requirement.jobTitle, requirement.statuses],
      ["Cost Center", "Requirement Create Time", "No Of Position", "Pincode", requirement.costCenterbig, requirement.datestimes, requirement.noOfPosition, requirement.pincode],
    ].map((row, idx) => (
      <React.Fragment key={idx}>
        {/* Headings Row */}
        <tr>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[3]}</th>
        </tr>

        {/* Values Row */}
        <tr>
          <td>{row[4] || "-"}</td>
          <td>{row[5] || "-"}</td>
          <td>{row[6] || "-"}</td>
          <td>{row[7] || "-"}</td>
        </tr>
      </React.Fragment>
    ))}

    <tr>
       <th style={{ backgroundColor: "#e9ecef" }}>Keywords</th>
        <td colSpan="3">N/A</td>
    </tr>
  </tbody>
</table>


<h5 className="mt-4"><strong>Statistics Overview</strong></h5>
{/* New Statistics Overview Table */}
<table className="table table-bordered mt-4" style={{ tableLayout: 'fixed', width: '100%' }}>
  <tbody>
    {requirement && [
      ["Total Candidates", "Vendor Candidates", "Recruiter Candidates", requirement.tcandidate, requirement.vcandidate, requirement.rcandidate],
      ["Total Campaigns", "Campaign IVR Completed", "Campaign IVR Pending", requirement.tcampaign, requirement.isuccess, requirement.ipending],
      ["IVR Total Call ( Candidates )", "IVR Pending ( Candidates )", "IVR Completed ( Candidates )", requirement.ivrtotal, requirement.ivrpending, requirement.ivrcompleted],
      ["Lineups Candidates", "Selected Candidates", "Joined Candidates", requirement.lineup, requirement.selected, requirement.joined]
    ].map((row, idx) => (
      <>
        {/* Headings row */}
        <tr key={`st-head-${idx}`}>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
        </tr>

        {/* Values row */}
        <tr key={`st-val-${idx}`}>
          <td>{row[3]}</td>
          <td>{row[4]}</td>
          <td>{row[5]}</td>
        </tr>
      </>
    ))}
  </tbody>
</table>


        
            </div>
            <div className='modal-footer' style={{ padding: '0px' }}>
              <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" id="okayClose" aria-label="Close">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal effect-flip-vertical fade" id="sourceModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="sourceModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="sourceModal"> {metaData.manager=== 1 ? 'Select Sourcing Manager' : metaData.bd=== 1 ? 'Select Sourcing Head' : 'Select Recruiter/Vendor'}</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="okayClose2" aria-label="Close"></button>
            </div>

            <div className='d-flex'>
              <form id="SourceForm" className="order-1" onSubmit={SourceForm}>

                <div className="modal-body">

                  <div className="row g-3">

<div className='col-6'>
<div className='col-xl-12 col-lg-12 col-md-12'>
                      <label htmlFor="branch" className="form-label">CLIENT NAME</label>
                      <input type="text" id='clients' name='clients' className="form-control" placeholder="Client" readOnly />
                    </div>

                   <div className='col-xl-12 col-lg-12 col-md-12'>
                      <label htmlFor="contract" className="form-label">LOCATION</label>
                      <input type="text" id='locations' className="form-control" placeholder="location" readOnly />
                    </div>
</div>

<div className='col-6'>
          {(metaData.typess?.toUpperCase() === "STAFF" &&  metaData.bd === 1) && (
                    <div className='col-xl-12 col-lg-12 col-md-12'>
                      <label htmlFor='' className='form-label'>Select Source Head</label>
                      <Select
                        options={team}   // must be an array
                        isMulti
                        closeMenuOnSelect={false}
                        value={team.filter(opt => selectedTeam.includes(opt.value))}
                        onChange={(options) => setSelectedTeam(options.map(opt => opt.value))}
                        placeholder="Select Sourcing Head"
                      />
                    </div>
           )}

           {(metaData.typess?.toUpperCase() === "STAFF" &&  metaData.manager === 1) && (
                    <div className='col-xl-12 col-lg-12 col-md-12'>
                      <label htmlFor='' className='form-label'>Select Source Manager</label>
                      <Select
                        options={team}   // must be an array
                        isMulti
                        closeMenuOnSelect={false}
                        value={team.filter(opt => selectedTeam.includes(opt.value))}
                        onChange={(options) => setSelectedTeam(options.map(opt => opt.value))}
                        placeholder="Select Sourcing Manager"
                      />
                    </div>
           )}

           {(metaData.typess?.toUpperCase() === "STAFF" &&  metaData.showManager === 1) && (
                   <>
                   <div className='col-xl-12 col-lg-12 col-md-12'>
                      <label htmlFor='' className='form-label'>Select Recruiter</label>
                      <Select
                        options={team}   // must be an array
                        isMulti
                        closeMenuOnSelect={false}
                        value={team.filter(opt => selectedTeam.includes(opt.value))}
                       onChange={(options) => setSelectedTeam(options.map(opt => opt.value))}
                        placeholder="Select Recruiter"
                      />
                    </div>
                    <div className='col-xl-12 col-lg-12 col-md-12'>
                      <label htmlFor='' className='form-label'>Vendor</label>
                      <Select
                        options={vendor}   // must be an array
                        isMulti
                        closeMenuOnSelect={false}
                        value={vendor.filter(opt => selectedVendor.includes(opt.value))}
                        onChange={(options) => setSelectedVendor(options.map(opt => opt.value))}
                        placeholder="Select Vendor"
                      />
                    </div> 
                    </>
           )}           
</div>
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <label htmlFor="contactName" className="form-label">DESIGNATION</label>
                      <input type="text" id='posts' className="form-control" placeholder="Designation" readOnly />
                    </div>
                    

                    <div className="col-lg-12" style={{ textAlign: 'right' }}>
                      <input type="hidden" name="hiddens" id="hiddens" />
                      <input type="hidden" name="types" id="type" />
                      <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                    </div>
                    <div className='col-lg-12'>
                      <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                  </div>

                </div>

              </form>

              <img className="order-2" src={process.env.PUBLIC_URL + "/admin_assets/images/media/media-69.svg"} style={{ width: '35%', height: '100%' }} />
            </div>

          </div>
        </div>
      </div>

      <div className="modal fade" id="rejectModal" tabIndex="-1" style={{zIndex:'99999'}} aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Reject with Remark</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div className="modal-body">
        <textarea
          className="form-control"
          rows="4"
          value={rejectremark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter your reason for rejection..."
        />
        <div className='text-right mt-2' style={{textAlign:'right'}}>
            
              <button
          type="button"
          className="btn btn-danger me-3"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            if (!rejectremark.trim()) {
              alert("Please enter a remark before rejecting.");
              return;
            }
            $("#rejectModal .btn-close").click();
            Action(rejectId, 'reject', rejectremark); // pass remark to API
          }}
        >
          Submit
        </button>

        </div>
      </div>
    </div>
  </div>
      </div>

      <div className="offcanvas offcanvas-start" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' ,width:'88%'}} tabIndex="-1" id="POAmodal" >
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1">POA</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
          
         {poatype === 1 ? (
            <>
          <div className='d-flex flex-column' style={{gap:'30px'}}>
        {poatypes === 1 && (
<>
           
            <div className='d-flex flex-row' style={{gap:'30px'}}>
            <form id="poaForm" onSubmit={PoaSubmit} encType="multipart/form-data" className='order-2'>
              <div className="row g-3">
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="first" className="form-label">FIRST WEEK</label>
                  <input id="first" name="first" type="text" className="form-control" placeholder="First Week Number" required onChange={poaHandleChange} value={poaDataa.first}/>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="second" className="form-label">SECOND WEEK</label>
                  <input id="second" name="second" type="text" className="form-control" placeholder="Second Week Number" required onChange={poaHandleChange} value={poaDataa.second}/>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="third" className="form-label">THIRD WEEK</label>
                  <input id="third" name="third" type="text" className="form-control" placeholder="Third Week Number" required onChange={poaHandleChange} value={poaDataa.third}/>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="fourth" className="form-label">FOURTH WEEK</label>
                  <input id="fourth" name="fourth" type="text" className="form-control" placeholder="Fourth Week Number" required onChange={poaHandleChange} value={poaDataa.fourth}/>
                </div>
            
                <div className='col-12' >
                  <input type="hidden" name="hidden" id="hidden" onChange={poaHandleChange} value={poaDataa.hidden}/>
                  <input type='hidden' name='aid' id='aid' value={aid} />
                  <input type='hidden' name="poaid" id="poaid" onChange={poaHandleChange} value={poaDataa.poaid}/>
                  <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </div>
            </form>
            <img className="order-1" src={process.env.PUBLIC_URL + "/images/media/media-90.svg"} style={{ width: '42%', height: '100%' }} />
            </div>
</>
 )}
     
            <div>
  <div className="col-12"> 
            {/* Assigned Staff */}
            <div className="card custom-card shadow-sm">

<div className="card-header justify-content-between">
    <div className="card-title">POA History</div>
</div>
  <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Week 1</th>
                          <th>Week 2</th>
                          <th>Week 3</th>
                          <th>Week 4</th>
                        </tr>
                      </thead>
                  <tbody>
  {poaHistory &&  poaHistory.length > 0 ? (
    poaHistory.map((s, i) => (
      <tr key={i}>
<td>
  <span className={`badge bg-${s.status.toUpperCase() === 'PENDING' ? 'danger' : 'success'}`}>
    {s.status.toUpperCase()}
  </span>
</td>
        <td>{s.dates}</td>
         <td>{s.first}</td>
        <td>{s.second}</td>
        <td>{s.third}</td>
        <td>{s.fourth}</td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center text-muted">No records found</td>
    </tr>
  )}
</tbody>


                    </table>
            </div>
          </div>

            </div>
        </div>
            </>
          ) : (
         <div className='d-flex flex-column' style={{gap:'30px'}}> 
        <div className="d-flex gap-5">
          <div className="d-flex flex-column align-items-center" style={{width:'35%'}}>
             <img  src={process.env.PUBLIC_URL + "/images/media/media-90.svg"} style={{ width: '65%', height: '100%' }} />
          
          <div className="col-12"> 
           
            <div className="card custom-card shadow-sm">

<div className="card-header justify-content-between">
    <div className="card-title">Requirement Details</div>
</div>
                <table className="table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <th>Client</th>
                  {poaData ? (
  <>
    <td>{poaData.clientName}</td>
  </>
) : (
  <td className="text-muted">Loading...</td>
)}
                      
                    </tr>
                    <tr>
                      <th>Designation</th>
           {poaData ? (
  <>
    <td>{poaData.designation}</td>
  </>
) : (
  <td className="text-muted">Loading...</td>
)}
                    </tr>
                    <tr>
                      <th>Location</th>
  {poaData ? (
  <>
    <td>{poaData.location}</td>
  </>
) : (
  <td className="text-muted">Loading...</td>
)}
                    </tr>
                  </tbody>
                </table>
            </div>
            </div>

            <div className="col-12"> 
            {/* Assigned Staff */}
            <div className="card custom-card shadow-sm">

<div className="card-header justify-content-between">
    <div className="card-title">Assigned To</div>
</div>

                <table className="table table-bordered table-sm" style={{textAlign:'left'}}>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  {poaData && poaData.assign && poaData.assign.length > 0 ? (
                       poaData.assign.map((a, i) => (
                      <tr key={i}>
                        <td>{a.name} 
                         <span className="badge badge-md bg-primary-transparent fs-10" style={{marginLeft:'10px'}}>{a.post.toUpperCase()}</span>
                        </td>
                        <td>
                          <span class={"badge bg-"+(a.type=="STAFF" ? 'secondary' : 'success')}>{a.type}</span>
                        </td>
                        <td>
                          <span class={"badge bg-"+(a.status=="reject" ? 'danger' : 'primary')}>{a.status=='reject'? 'Cancelled' : 'Active'}</span>
                        </td>
                      </tr>
))
  ) : (
    <tr>
      <td colSpan="6" className="text-center text-muted">No records found</td>
    </tr>
  )}
                  </tbody>
                </table>
            </div>
          </div>
          </div>


            {/* Staff vs Vendor Data */}
            <div className="d-flex flex-column" style={{width:'65%'}}>
              {/* Staff */}
              <div className="col-12">
                <div className="card custom-card shadow-sm">

<div className="card-header justify-content-between pb-2 pt-1">
    <div className="card-title">Staff Wise Details</div>
</div>
                    <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Name</th>
                          <th>Week 1</th>
                          <th>Week 2</th>
                          <th>Week 3</th>
                          <th>Week 4</th>
                          <th colSpan={2}>Action</th>
                        </tr>
                      </thead>
                  <tbody>
  {poaData && poaData.staffWise && poaData.staffWise.length > 0 ? (
    poaData.staffWise.map((s, i) => (
      <tr key={i}>
        <td>{s.status.toUpperCase()}</td>
        <td>{s.datetime}</td>
        <td>{s.name}</td>        <td>{s.week1}</td>
        <td>{s.week2}</td>
        <td>{s.week3}</td>
        <td>{s.week4}</td>

<td>
  {s.status.toLowerCase() === "pending" ? (
    <>
      <button
        className="btn btn-sm btn-success-light me-1"
        onClick={() => Action(s.poaid, "success")}
      >
        Accept
      </button>
      <button
        className="btn btn-sm btn-danger-light"
        onClick={() => {
          setRejectId(s.poaid);
          setRemark("");
          $("#reject_modalbtn").click();
        }}
      >
        Reject
      </button>
    </>
  ) : s.status.toLowerCase() === "success" ? (
    <span className="badge bg-success">ACCEPTED</span>
  ) : (
    <span className="badge bg-danger">REJECTED</span>
  )}
</td>

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center text-muted">No records found</td>
    </tr>
  )}
</tbody>


                    </table>
                </div>
              </div>

              {/* Vendor */}
              <div className="col-12">
                <div className="card custom-card shadow-sm">
                 <div className="card-header justify-content-between">
    <div className="card-title">Vendor Wise Details</div>
</div>
                  <table className="table table-bordered table-sm text-nowrap">
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Name</th>
                          <th>Week 1</th>
                          <th>Week 2</th>
                          <th>Week 3</th>
                          <th>Week 4</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
  {poaData && poaData.vendorWise && poaData.vendorWise.length > 0 ? (
    poaData.vendorWise.map((v, i) => (
     <tr key={i}>
        <td>{v.status.toUpperCase()}</td>
        <td>{v.datetime}</td> <td>{v.name}</td> 
        <td>{v.week1}</td>
        <td>{v.week2}</td>
        <td>{v.week3}</td>
        <td>{v.week4}</td>
 
<td>
  {v.status.toLowerCase() === "pending" ? (
    <>
      <button
        className="btn btn-sm btn-success-light me-1"
        onClick={() => Action(v.poaid, "success")}
      >
        Accept
      </button>
      <button
        className="btn btn-sm btn-danger-light"
        onClick={() => {
          setRejectId(v.poaid);
          setRemark("");
          $("#reject_modalbtn").click();
        }}
      >
        Reject
      </button>
    </>
  ) : v.status.toLowerCase() === "success" ? (
    <span className="badge bg-success">ACCEPTED</span>
  ) : (
    <span className="badge bg-danger">REJECTED</span>
  )}
</td>


      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center text-muted">
        No records found
      </td>
    </tr>
  )}
</tbody>

                    </table>
           
                </div>
              </div>
            </div>
          </div>
          </div>
        )}
      

       
        </div>

      </div>
      
       <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal" >
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1" style={{fontSize:'18px',fontWeight:'bold'}}>Create Requirement</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
          <div className='d-flex'>

            <form id="submitform" method='post' onSubmit={FormSubmit} encType="multipart/form-data" className='order-2'>
              <div className="row g-3">
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="clientName" className="form-label"><span className='text-danger fs-15'>*</span>CLIENT NAME</label>
                  <Select
                    options={client}   // must be an array
                    value={(client || []).find(opt => opt.value == selectedClient) || null}
                    onChange={(option) => setSelectedClient(option ? option.value : null)}
                    placeholder="Select Client"
                  />

                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="branch" className="form-label"><span className='text-danger fs-15'>*</span>BRANCH</label>
                  <input id="branchh" name="branchh" type="text" className="form-control" placeholder="Branch" required />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="contactName" className="form-label"><span className='text-danger fs-15'>*</span>CONTACT NAME</label>
                  <input id="contactName" name="contactName" type="text" className="form-control" placeholder="Contact Name" required/>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="contract" className="form-label"><span className='text-danger fs-15'>*</span>CONTRACT</label>
                  <input id="contract" name="contract" type="text" className="form-control" placeholder="Contract" required />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="anchor" className="form-label"><span className='text-danger fs-15'>*</span>ANCHOR</label>
                  <input id="anchor" name="anchor" type="text" className="form-control" placeholder="Anchor" required />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="placementType" className="form-label"><span className='text-danger fs-15'>*</span>PLACEMENT TYPE</label>
                   <Select options={placementType || []} value={(placementType || []).find(opt => opt.value === selectPlace) || null}
                    onChange={(option) => setPlacement(option ? option.value : null)} placeholder="Select Placement"
                   />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="location" className="form-label"><span className='text-danger fs-15'>*</span>LOCATION</label>
                  <input id="location" name="location" type="text" className="form-control" placeholder="location" required />
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="designation" className="form-label"><span className='text-danger fs-15'>*</span>DESIGNATION</label>
                  <Select
                    options={reqpost || []}   // prevent null crash
                    value={reqpost.filter(opt => designation.includes(opt.value))}
                    onChange={(options) => setDesignation(options.map(opt => opt.value))}
                    placeholder="Select Designation"
                    isMulti
                    closeMenuOnSelect={false}
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="jobTitle" className="form-label">JOB TITLE</label>
                  <input id="jobTitle" name="jobTitle" type="text" className="form-control" placeholder="Job Title" />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="education" className="form-label"><span className='text-danger fs-15'>*</span>EDUCATION</label>
                                <Select
                                      options={qualificationOptions || []}   // must be an array
                                      isMulti
                                      closeMenuOnSelect={false}
                                      value={qualificationOptions.filter(opt => education.includes(opt.value))}
                                      onChange={(options) => setEducation(options.map(opt => opt.value))}
                                      placeholder="Select Qualification"
                                    />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="noOfPosition" className="form-label"><span className='text-danger fs-15'>*</span>NO. OF POSITION</label>
                  <input id="noOfPosition" name="noOfPosition" type="text" className="form-control" placeholder="No. of Position" required />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="pincode" className="form-label">PINCODE</label>
                  <input id="pincode" name="pincode" type="text" className="form-control" placeholder="Pincode" />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="costCenter" className="form-label"><span className='text-danger fs-15'>*</span>COST CENTER</label>
                  <Select
                    options={costCenterOptions || []}   // must be an array
                    value={(costCenterOptions || []).find(opt => opt.value == selectedCost) || null}
                    onChange={(option) => setCost(option ? option.value : null)}
                    placeholder="Select Center"
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="commercials" className="form-label">COMMERCIALS</label>
                  <input id="commercials" name="commercials" type="text" className="form-control" placeholder="Commercials" />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6" >
                  <label className="form-label"><span className='text-danger fs-15'>*</span>Gender</label>

                  <Select
                    options={GenderOptions}   // must be an array
                    value={GenderOptions.find(opt => opt.value == selectedGender) || undefined}
                    onChange={(option) => setGender(option ? option.value : '')}
                    placeholder="Select Gender"
                  />
                  <input type="hidden" name="gender" value={selectedGender} required />

                </div>
               <div className="col-xl-5 col-lg-5 col-md-12">
  <label className="form-label">
    <span className='text-danger fs-15'>*</span> REQUIREMENT PLAN DATE (RANGE)
  </label>
  <Flatpickr
  className="form-control"
  value={[dates.planFromDate, dates.planToDate]}
  onChange={(selectedDates) => {
    setDates({
      planFromDate: selectedDates[0] || null,
      planToDate: selectedDates[1] || null,
    });
  }}
  options={{
    mode: "range",
    dateFormat: "l, d F Y",
    showMonths: 2
  }}
  placeholder="Select Date Range (Required)"
/>

</div>
                <div className='col-xl-1 col-lg-1 col-md-1'></div>
                <div className="col-xl-5 col-lg-5 col-md-12">
                  <label className="form-label"><span className='text-danger fs-15'>*</span>CTC RANGE(PER ANNUM)</label>
                  <div className="row g-3">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <input id="ctcFrom" name="ctcFrom" type="text" className="form-control" placeholder="From" required />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <input id="ctcTo" name="ctcTo" type="text" className="form-control" placeholder="To" required />
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 col-lg-5 col-md-12">
                  <label className="form-label"><span className='text-danger fs-15'>*</span>EXP. RANGE(IN YEARS)</label>
                  <div className="row g-3">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <input id="expFrom" name="expFrom" type="text" className="form-control" placeholder="From" required />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <input id="expTo" name="expTo" type="text" className="form-control" placeholder="To" required />
                    </div>
                  </div>
                </div>
                <div className='col-xl-1 col-lg-1 col-md-1'></div>
                <div className="col-xl-5 col-lg-5 col-md-12">
                  <label className="form-label"><span className='text-danger fs-15'>*</span>AGE RANGE(IN YEARS)</label>
                  <div className="row g-3">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <input id="ageFrom" name="ageFrom" type="text" className="form-control" placeholder="From" />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <input id="ageTo" name="ageTo" type="text" className="form-control" placeholder="To" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <label htmlFor="keywords" className="form-label">KEYWORDS</label>
                  <input id="keywords" name="keywords" type="text" className="form-control" placeholder="Keywords" />
                </div>
                <div className="col-lg-12">
                  <label htmlFor="jobDescription" className="form-label">JOB DESCRIPTION</label>
                  <ReactQuill
                    theme="snow"
                    value={jobDescription}
                    onChange={setJobDescription}
                    style={{ maxHeight: "300px", overflowX: 'auto', border: "1px solid darkgrey", borderRadius: '10px' }}
                  />
                </div>
                <div className='col-12' style={{
                  padding: "7px 20px",
                  textAlign: "right",
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  background: "#fff",
                  boxShadow: "-4px -4px 4px darkgrey",
                }}>
                  <input type="hidden" name="hidden" id="hidden" />
                  <input type='hidden' name='aid' id='aid' value={aid} />
                  <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  <button type="submit"id="mainSubmit" className="btn btn-primary">Submit</button>
                </div>
              </div>
            </form>

           
          </div>

        </div>

      </div>

      <div className="main-content app-content">

        <div className="container-fluid">


  <div className="row">

<div class="col-xl-12 mt-4">
    <div class="card custom-card">
        <div class="card-header"><div class="card-title">Requirements Summary</div></div>
        <div class="card-body">
            <div class="row gy-md-0 gy-3" style={{gap:'15px 60px'}}>

 {stats.map((item, index) => (
 
 <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class={"avatar avatar-rounded text-white"} style={{backgroundColor:item.color}}>
                                <i class={`${item.icon} fs-28`}></i>
                            </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">{item.label}</span>
                            <h6 class="fw-semibold mb-0">{item.count}</h6>
                        </div>
                    </div>
                </div>

  ))}

            </div>
        </div>
    </div>
</div>

</div>

          <div className="row">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="card custom-card">
                <div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                  <div style={{width:'55%',display:'flex',gap:'20px'}}>
                      <input type="search" className="form-control"  placeholder="Search By RECID,CLIENT,LOCATION,POSITION,DESIGNATION" id="search-member"  value={globalFilterText}
                    onChange={(e) => setGlobalFilterText(e.target.value)} />
                    <Flatpickr
    className="form-control"
    // Use the array directly from state
    value={searchData.dateRange} 
    onChange={(update) => {
      setSearchData(prev => ({
        ...prev,
        dateRange: update 
      }));
    }}
    options={{ 
      mode: "range", 
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d M Y",
      allowInput: true
    }}
    placeholder="Select range..."
  />
                    </div>
                
                  <div className="d-flex mt-sm-0 mt-2 align-items-center">

               {metaData.add ===1 && typeUpper==='STAFF' && (
                      <button className="btn btn-primary" data-bs-toggle="offcanvas" data-bs-target="#exampleModal" id='addStaffbtn'><i className="ri-add-line" data-tooltip-content="Add Requirement" data-tooltip-id="global-tooltip"></i>Add Requirement</button>
                )}
                    
                  
                  </div>

                </div>
                <div className="card-body" style={{ padding: '0px' }}>

           <TableContainer sx={{ maxHeight: '700px'}}>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {processedData.map((row, index) => (
                            <TableRow 
                                key={index} 
                                
                            >
                                {columns.map((column) => {
                                    const value = column.selector ? column.selector(row) : null;
                                    
                                    let cellContent;

                                    // Custom rendering logic
                                    if (column.accessorKey === 'rid') {
                                        cellContent = <RenderReqIdCell row={row} />;
                                    } else if (column.accessorKey === 'statues' && metaData.bd == 1) {
                                        cellContent = <RenderStatusSelectCell row={row} type="1"/>;
                                    }
                                    else if (column.accessorKey === 'bd_poa' && metaData.bd == 1) {
                                        cellContent = <RenderStatusSelectCell row={row} type="44"/>;
                                    }
                                     else if (column.accessorKey === 'assign' && (metaData.bd == 1 || metaData.vendor == 1)) {
                                        const type=metaData.bd===1 ? "2" : "3";
                                        cellContent = <RenderStatusSelectCell row={row} type={type}/>;
                                    }
                                     else if (column.accessorKey === 'poa' && (metaData.poaShow == 1 || metaData.vendor == 1)) {
                                        const type=metaData.poaShow===1 ? "4" : "5";
                                        cellContent = <RenderStatusSelectCell row={row} type={type}/>;
                                    }
                                    
                                    else if(column.accessorKey === 'rstatus'){
                                      const value = column.selector ? column.selector(row) : null;
                                      cellContent =<RenderStatusChip value={value} rowId={row} statusType="rremark"/>}
                                    else if (column.accessorKey === 'actions') {
                                        cellContent = <RenderActionCell rowData={row} metaData={metaData} />;
                                    } 
                                    else {
                                        const value = column.selector ? column.selector(row) : null;
                                        cellContent = value;
                                    }

                                    return (
                                        <TableCell 
                                            key={column.accessorKey}
                                            sx={{ p: 1.5, fontSize: '0.875rem'}}>
                                            {cellContent}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                        
                        {/* Empty state if no data */}
                        {processedData.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                                    <Typography color="textSecondary" variant="body1">
                                        No requirements found matching the current filters.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
          
                </div>
                <div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Copy;
